import * as React from "react";

export type LoginAccountContextType = {
  accountNotLinked: boolean | null;
  googleEmail: string | null;
  setAccountNotLinked: React.Dispatch<React.SetStateAction<boolean | null>>;
  setGoogleEmail: React.Dispatch<React.SetStateAction<string | null>>;
  promptIfNotLoggedIn: (
    callback: Function,
    closeCallback?: Function,
    to?: any,
    from?: any,
  ) => void;
};

export const LoginContext = React.createContext<
  LoginAccountContextType | undefined
>(undefined);

export const useLoginContext = (): LoginAccountContextType => {
  const context = React.useContext(LoginContext);
  if (!context) {
    throw new Error(
      "useLoginContext must be used within a LoginContextProvider",
    );
  }
  return context;
};
